export default {
  /**
   * Flatten an objects nested properties to a single depth.
   * Flattened property names reflect the path in the original object.
   *
   * Example:
   *  {
   *    foo: {
   *        bar: {
   *            baz: "Hello world"
   *        }
   *    }
   * }
   *
   * Will be flattened into
   * {
   *    foo_bar_baz: "Hello world"
   * }
   *
   * @param {Object} obj The initial object to flatten
   * @param {String} parent The key of the parent object
   * @param {Function} fieldFormatter A function which is applied to object values. Returns original value by default
   * @param {String} delimiter The delimiter used to separate flattened keys
   *
   * @returns {Object} The flattened object
   *
   */
  flattenObject(obj, parent, result = {}, fieldFormatter = (key, val) => val, delimiter = '_') {
    for (const key in obj) {
      if (key) {
        const propName = parent ? `${parent}${delimiter}${key}` : key;
        if (typeof obj[key] === typeof {} && !Array.isArray(obj[key])) {
          this.flattenObject(obj[key], propName, result, fieldFormatter, delimiter);
        } else {
          const formatted = fieldFormatter(propName, obj[key]);
          result[propName] = formatted;
        }
      }
    }
    return result;
  },
};
